import StartEndDateTime from '~/components/forms/StartEndDateTime';
import React from 'react';

const SingleEvent = ({ event, isFirst }) => {
    const clientTz = event.client_timezone;

    return (
        <div className={`${!isFirst ? 'border-t' : ''} py-3 pr-4`}>
            {!!event?.form_submission?.confirmation_url && (
                <div
                    className="cursor-pointer flex items-center justify-between"
                    onClick={() => {
                        if (event?.form_submission?.confirmation_url) {
                            window.open(
                                event?.form_submission?.confirmation_url,
                            );
                        }
                    }}
                >
                    <div>
                        <div>{event.event_type?.name}</div>
                        <div className="text-gray-500">
                            {event.name}
                            {!!event.bookable_resource?.name
                                ? ` booked with ${event?.bookable_resource?.name}`
                                : ''}
                        </div>

                        <div className="text-gray-500 mt-2 leading-tight">
                            <StartEndDateTime
                                start={event?.client_start}
                                end={event?.client_end}
                                clientTz={clientTz}
                            />
                        </div>
                    </div>
                    {!!event?.form_submission?.confirmation_url && (
                        <>
                            {!!event?.canceled_at && (
                                <div className="text-red-700 font-semibold">
                                    Canceled
                                </div>
                            )}
                            {!event?.canceled_at && (
                                <button className="form-button btn-small">
                                    View
                                </button>
                            )}
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

const EventHistory = ({ events }) => {
    const now = new Date();

    const upcomingEvents = events
        .filter(ev => new Date(ev.start) > now)
        .sort((a, b) => new Date(a.start) - new Date(b.start));
    const pastEvents = events
        .filter(ev => new Date(ev.start) < now)
        .sort((a, b) => new Date(b.start) - new Date(a.start));

    return (
        <div>
            <div className="panel-label">Upcoming Events</div>
            <div className="panel pl-4">
                {upcomingEvents.map((ev, idx) => (
                    <SingleEvent event={ev} isFirst={idx === 0} />
                ))}
                {upcomingEvents.length === 0 && (
                    <div className="py-3">
                        There are no upcoming events
                    </div>
                )}
            </div>

            <div className="panel-label mt-6">Past Events</div>
            <div className="panel pl-4">
                {pastEvents.map((ev, idx) => (
                    <SingleEvent event={ev} isFirst={idx === 0} />
                ))}
                {pastEvents.length === 0 && (
                    <div className="text-gray-500 py-3">
                        There are no past events
                    </div>
                )}
            </div>
        </div>
    );
};

export default EventHistory;
